import PickupPointsService from "../../services/pickupPoints.service";

const pickupPointsModule = {
  namespaced: true,
  state: {
    loaded: false,
    points: [],
  },
  getters: {
    getPoints(state) {
      return state.points;
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const points = await PickupPointsService.fetch();
        commit('setPoints', points.data);
      } catch (e) {
        console.log(e);
      }
      commit('setLoaded', true);
    }
  },
  mutations: {
    setPoints(state, value) {
      state.points = value;
    },
    setLoaded(state, value) {
      state.loaded = value;
    },
    reset(state) {
      Object.assign(state, {
        points: [],
      });
    }
  },
};

export default pickupPointsModule;